import React, { useState, useRef } from "react";
import TagButton from "../common/TagButton";

const Image1 = "https://storage.googleapis.com/think41-web-new/assets/Career/Image1.png";
const Image2 = "https://storage.googleapis.com/think41-web-new/assets/Career/Image2.png";
const Image3 = "https://storage.googleapis.com/think41-web-new/assets/Career/Image3.png";
const Image4 = "https://storage.googleapis.com/think41-web-new/assets/Career/Image4.png";
const Image5 = "https://storage.googleapis.com/think41-web-new/assets/Career/Image5.png";
const Image6 = "https://storage.googleapis.com/think41-web-new/assets/Career/Image6.png";
const Image7 = "https://storage.googleapis.com/think41-web-new/assets/Career/Image7.png";
const Image8 = "https://storage.googleapis.com/think41-web-new/assets/Career/Image8.png";
const Image9 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage9.png";
const Image10 = "https://storage.googleapis.com/think41-web-new/assets/Career/Image10.png";
const Image11 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage11.png";
const Image12 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage12.png";
const Image13 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage13.png";
const Image14 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage14.png";
const Image15 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage15.png";
const Image16 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage16.png";
const Image17 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage17.png";
const Image18 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage18.png";
const Image19 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage19.png";
const Image20 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage20.png";
const Image21 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage21.png";
const Image22 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage22.png";
const Image23 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage23.png";
const Image24 = "https://storage.googleapis.com/think41-web-new/assets/Career/IMage24.png";

const PolygonWebVector = "https://storage.googleapis.com/think41-web-new/assets/Career/00%20polygon%20web%20vector%20updated.svg";
const teamPhoto = "https://storage.googleapis.com/think41-web-new/assets/Career/team_pic.svg";


const LifeAtThink41 = () => {
  const [isHovered, setIsHovered] = useState(false);
  const containerRef = useRef(null);

  const gridImages = [
    teamPhoto, // Include main image in the animation grid
    Image1,
    Image2,
    Image3,
    Image4,
    Image5,
    Image6,
    Image7,
    Image8,
    Image9,
    Image10,
    Image11,
    Image12,
    Image13,
    Image14,
    Image15,
    Image16,
    Image17,
    Image18,
    Image19,
    Image20,
    Image21,
    Image22,
    Image23,
    Image24,
  ];

  return (
    <div className="h-full w-full overflow-hidden relative">
      {/* Background PolygonWebVector with opacity */}
      <div
        aria-hidden="true"
        style={{
          backgroundImage: `url(${PolygonWebVector})`,
          backgroundRepeat: "repeat",
          backgroundSize: "80vw auto",
          backgroundPosition: "left top",
          opacity: 0.8,
          position: "absolute",
          inset: 0,
          zIndex: 0,
          pointerEvents: "none",
        }}
      />
      <div className="w-full h-full bg-[#E8EBF0]">
        <section className="relative md:max-w-[1440px] h-[600px] md:h-[1000px] overflow-hidden mx-auto">
          {/* Grid background lines */}
          <div
            className="absolute inset-0 z-0 pointer-events-none"
            style={{
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0' y='0' width='10' height='30' fill='none'/%3E%3Crect x='0' y='0' width='30' height='10' fill='none'/%3E%3Cline x1='10' y1='0' x2='10' y2='30' stroke='%23e5e5e5' stroke-width='1' stroke-opacity='0.5' stroke-dasharray='4,4'/%3E%3Cline x1='0' y1='10' x2='30' y2='10' stroke='%23e5e5e5' stroke-width='1' stroke-opacity='0.5' stroke-dasharray='4,4'/%3E%3C/svg%3E")`,
              backgroundSize: "30px 30px",
            }}
          />

          {/* Heading */}
          <div className="md:max-w-[1200px] w-full mx-auto px-[20px] md:px-0 md:pt-10 z-10 relative life-heading-wrapper mb-[36px]">
            <div className="md:mb-6 mt-[36px] md:mt-0">
              <TagButton text="Gallery" />
            </div>
            <svg width="0" height="0">
              <linearGradient
                id="lifeatthink41-gradient"
                x1="0"
                y1="0"
                x2="1"
                y2="0"
              >
                <stop offset="0%" stopColor="#000000" />
                <stop offset="100%" stopColor="#0060C7" />
              </linearGradient>
            </svg>
            <h2
              className="text-[24px] md:text-[40px] font-semibold leading-[53px] font-montserrat mt-4 life-heading-text"
              style={{
                background: "linear-gradient(90deg, #000000 0%, #0060C7 100%)",
                backgroundImage:
                  "linear-gradient(90deg, #000000 0%, #0060C7 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                color: "transparent",
                MozBackgroundClip: "text",
                MozTextFillColor: "transparent",
                display: "inline-block",
              }}
            >
              Life @ Think41
            </h2>
          </div>

          {/* Hover area */}
          <div
            ref={containerRef}
            className="relative max-w-[1200px] w-full h-[700px] mx-auto rounded-xl overflow-hidden z-10 hidden md:block"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {/* Main image background */}
            <img
              src={teamPhoto}
              alt="Main Team"
              className={`absolute inset-0 w-full h-full object-cover transition-all duration-1000 ease-out rounded-xl
            ${
              isHovered
                ? "opacity-0 scale-90 z-0"
                : "opacity-100 scale-100 z-10"
            }`}
            />

            {/* Image grid */}
            <div
              className={`absolute inset-0 grid grid-cols-2 md:grid-cols-5 gap-2 transition-opacity duration-700 ease-in-out md:mb-[36px] mb
            ${isHovered ? "opacity-100 z-10" : "opacity-0 z-0"}
          `}
            >
              {gridImages.map((img, index) => (
                <div
                  key={index}
                  className="rounded-lg overflow-hidden transform scale-90 opacity-0 animate-fade-in"
                  style={{
                    animationDelay: `${index * 50}ms`,
                    animationDuration: `600ms`,
                    animationFillMode: "forwards",
                    animationTimingFunction: "ease-out",
                    animationName: isHovered ? "fadeInScale" : "none",
                  }}
                >
                  <img
                    src={img}
                    alt={`Life at Think41 ${index}`}
                    className="w-full h-[150px] object-cover rounded-lg shadow"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Keyframes and Responsive */}
          <style jsx>{`
            @keyframes fadeInScale {
              0% {
                opacity: 0;
                transform: scale(0.6);
              }
              100% {
                opacity: 1;
                transform: scale(1);
              }
            }
            @keyframes moveBand {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(-50%);
              }
            }

            @media (max-width: 768px) {
              .mobile-gallery {
                display: flex;
                flex-direction: column;
                gap: 33px;
                overflow: hidden;
              }

              .band {
                display: flex;
                gap: 46px;
                animation: moveBand 20s linear infinite;
                width: max-content;
              }

              .band img {
                width: 275px;
                height: 183px;
                aspect-ratio: 275 / 183;
                border-radius: 8px;
                object-fit: cover;
                flex-shrink: 0;
              }
            }
          `}</style>

          {/* Mobile version */}
          <div className="mobile-gallery hidden md:hidden">
            {[0, 1].map((bandIndex) => {
              const images = gridImages.slice(
                bandIndex * 10,
                bandIndex * 10 + 10
              );
              return (
                <div className="band" key={bandIndex}>
                  {/* Duplicate the 10 images for smooth scroll */}
                  {[...images, ...images].map((img, index) => (
                    <img
                      key={`${bandIndex}-${index}`}
                      src={img}
                      alt={`Band${bandIndex + 1}-${index}`}
                    />
                  ))}
                </div>
              );
            })}
          </div>
        </section>
      </div>
    </div>
  );
};

export default LifeAtThink41;
